module.exports = __webpack_public_path__ + "img/classic.58bdb428.png";